export const CLIENT = {
  CMA: 'cma',
  MEDICAL_POINT: 'medical-point',
};
